import {BaseAnalyticsEvent} from "./base-analytics-event";

export class BaseAnalyticsShowEvent extends BaseAnalyticsEvent {

  constructor(name) {
    super('', 'show', name);
  }

  populate(event: BaseAnalyticsShowEvent) { }
}
